<template>
    <div class="container">
        <div class="row">
            <div class="col-12 center-container">
                <div class="item">
                    <span class="hh-brand"> Help Hub </span>
                    <span class="redirect-normal-container">is now </span>
                    <span class="employee-hub-text-container">Employee Hub</span>
                    <br><br>
                    <div class="redirecting-txt">
                        Redirecting to the new site. . .
                    </div>
                    <br>
                    <div class="eh-redirect-border-bottom-container">
                        <div class="eh-redirect-border-bottom">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "EmployeeHubRedirect",
        created(){
               window.location = EMPLOYEE_HUB_HOME_PAGE
        }
    }
</script>

<style scoped>
    .center-container{
        width: 100%;
        display: flex;
        height: 85vh;
        justify-content: center;
    }

    .item{
        align-self: center;
        color:#000;
        text-align:center;
    }

    .hh-brand{
        font-size: 65px;
    }

    .redirect-normal-container{
        font-size: 42px;
        font-weight:400;
    }

    .employee-hub-text-container{
        font-size: 65px;
        font-weight:bolder;
    }

    .redirecting-txt{
        font-size: 28px;
        width:100%;
        text-align:center;
    }

    .eh-redirect-border-bottom-container{
        text-align:center;
    }

    .eh-redirect-border-bottom{
        -o-background: linear-gradient(90deg,#0696d7,#32bcad 50.93%,#87bc40);
        background: -webkit-gradient(linear,left top,right top,from(#0696d7),color-stop(50.93%,#32bcad),to(#87bc40));
        background: linear-gradient(90deg,#0696d7,#32bcad 50.93%,#87bc40);
        height: 3px;
        width:5px;
        text-align:center;
        position: relative;
        animation: progress-indeterminate 1s linear infinite;

    }

    @keyframes progress-indeterminate {
        from {
            left: 0%;
            width: 30%;
        }
        to {
            left: 70%;
            width: 30%;
        }
    }

    @media only screen and (max-width: 768px) {
        .employee-hub-text-container{
            font-size: 42px;
        }
        .redirecting-txt{
            font-size: 16px;
        }
        .redirect-normal-container{
            font-size: 20px;
        }
        .hh-brand{
            font-size: 42px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/homepage/EmployeeHubRedirect.vue